import type { FleetPortalRole } from '@autoplan/common'

export {
  FLEET_PORTAL_ROLES,
  type FleetPortalRole,
  WEB_MODULE_PERMISSIONS,
  WEB_MODULES,
  type WebModule,
} from '@autoplan/common'

export interface FleetWebUserProfile {
  groupIds?: FleetPortalRole[]
  [claim: string]: unknown
}

export interface AccessTokenClaims {
  resource_access?: Record<string, { roles?: string[] }>
  groupIds?: FleetPortalRole[]
  [claim: string]: unknown
}

export type FleetWebUser =
  | {
      access_token?: string | null
      profile?: FleetWebUserProfile | null
    }
  | null
  | undefined

export const TASK_TYPES = ['ready-for-signing', 'sent-for-signing', 'selections'] as const

export type TaskType = (typeof TASK_TYPES)[number]

export const TASK_DEFAULT_TYPE: TaskType = 'ready-for-signing'

export const TASK_TAB_PARAM = 'tab'

export type ShellInfo = {
  language?: string
}
